<template>
	<div :class="[getGroupClass, {'form-group--error' : validate.$error}]">
		<label class="label" :for="id">{{label}}</label>
		<span :id="'textarea-ex-hint'+id" class="hint" v-if="hintText != ''">
			{{hintText}}
		</span>
		<span :id="'textarea-ex-error'+id" class="error-message" v-if="validate.$error">
			{{errorMessage}}
		</span>
		<textarea
			rows="5"
			:class="[getClass, {'textarea--error' : validate.$error}]"
			v-model="m"
			:name="name"
			:id="id"
			type="text"/>
	</div>
</template>

<script>
export default {
	name: 'Textarea',
	props: {
		id: {
			type: String,
			required: true,
			default: null
		},
		name: {
			type: String,
			required: true,
			default: null
		},
		type: {
			type: String,
			required: false,
			default: null
		},
		label: {
			type: String,
			required: true,
			default: null
		},
		value: {
			type: String,
			default: ""
		},
		validate: {
			type: Object,
			required: false
		},
		hintText: {
			type: String,
			default: null
		},
		errorMessage: {
			type: String,
			default: null
		},
	},
	data() {
		return {
			getClass: "textarea",
			getGroupClass: "form-group",
		}
	},
	computed: {
		m: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			}
		}
	}
}
</script>